import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { EmpresasService } from "../../../catalogs/empresas/empresas.service";
import { TiposUnidadService } from "../../../catalogs/tipos-unidades/tipos-unidades.service";
import * as dayjs from "dayjs";
import { UnidadesDTO } from "src/app/models/unidades.dto";
import * as FileSaver from "file-saver";
import mimeTypes from "src/app/utils/mime-types";
import { UnidadesService } from "../unidades.service";

@Component({
  selector: "app-form-unidad",
  templateUrl: "./form.component.html",
})
export class UnidadForm implements OnInit {
  public form: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: UnidadesDTO = undefined;

  public empresa: any[] = [];
  public empresaShow: any[] = [];
  public tipos: any[] = [];
  public estatus: any[] = [
    { Id: "R", Desc: "Trabajando" },
    { Id: "A", Desc: "En tramite" },
    { Id: "T", Desc: "Taller" },
    { Id: "Y", Desc: "Yarda" },
  ];
  @Output() onsave = new EventEmitter<{
    mode: string;
    value: any;
    poliza: File;
  }>();

  @ViewChild("polizaInput", { static: false })
  public polizaInput: ElementRef;
  polizaImg: string = "";
  polizaFile: File = undefined;
  constructor(
    private fb: FormBuilder,
    private empServ: EmpresasService,
    private tiposServ: TiposUnidadService,
    public service: UnidadesService
  ) {}

  public ngOnInit() {
    this.buildForm();
    this.empServ.get().subscribe((s) => {
      this.empresa = s;
    });
    this.tiposServ.get().subscribe((s) => {
      this.tipos = s;
    });
  }
  public setStanby() {
    this.mode = "stanby";
    this.defaults = undefined;
    this.form.reset();
  }
  public setCreate() {
    this.mode = "create";
    this.defaults = undefined;
    this.form.reset();
    this.form.controls["Estado"].patchValue("Y");
    this.form.controls["Estado"].disable();
    this.empresaShow = this.empresa.filter((f) => f.Activo);
  }

  public setUpdate(row: any) {
    this.mode = "update";
    this.defaults = row;
    this.form.controls["IdUnidad"].setValue(this.defaults?.IdUnidad);
    this.form.controls["IdEmpresa"].patchValue(this.defaults?.IdEmpresa);
    this.form.controls["IdTipoUnidad"].patchValue(this.defaults?.IdTipoUnidad);
    this.form.controls["NoControl"].patchValue(this.defaults?.NoControl);
    this.form.controls["Serie"].patchValue(this.defaults?.Serie);
    this.form.controls["Placas"].patchValue(this.defaults?.Placas);
    this.form.controls["Modelo"].patchValue(this.defaults?.Modelo);
    this.form.controls["NumeroMotor"].patchValue(this.defaults?.NumeroMotor);
    this.form.controls["Estado"].patchValue(this.defaults?.Estado);
    this.form.controls["FechaIngreso"].patchValue(
      this.defaults.FechaIngreso
        ? dayjs(this.defaults.FechaIngreso).format("YYYY-MM-DD")
        : null
    );
    this.form.controls["Estado"].disable();
    this.empresaShow = this.empresa.filter(
      (f) => f.Activo || f.IdEmpresa == this.defaults?.IdEmpresa
    );

    this.form.controls["PolizaFechaInicio"].patchValue(
      this.defaults.PolizaFechaInicio
        ? dayjs(this.defaults.PolizaFechaInicio).format("YYYY-MM-DD")
        : null
    );
    this.form.controls["PolizaFechaVencimiento"].patchValue(
      this.defaults.PolizaFechaVencimiento
        ? dayjs(this.defaults.PolizaFechaVencimiento).format("YYYY-MM-DD")
        : null
    );
  }

  public save() {
    if (this.mode === "create") this.create();
    else if (this.mode === "update") this.update();
  }

  public create() {
    this.onsave.emit({
      mode: this.mode,
      value: this.form.value,
      poliza: this.polizaFile,
    });
  }

  public update() {
    this.onsave.emit({
      mode: this.mode,
      value: this.form.value,
      poliza: this.polizaFile,
    });
  }

  public isCreateMode() {
    return this.mode === "create";
  }

  public isUpdateMode() {
    return this.mode === "update";
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      IdUnidad: [""],
      IdEmpresa: [""],
      IdTipoUnidad: [""],
      NoControl: [""],
      Serie: [""],
      Placas: [""],
      Modelo: [""],
      NumeroMotor: [""],
      Estado: ["Y"],
      FechaIngreso: [""],
      PolizaFechaVencimiento: [""],
      PolizaFechaInicio: [""],
    });
  }

  OpenPolizaSelect() {
    this.polizaInput.nativeElement.click();
  }

  public getPoliza(polizaInput: any) {
    if (polizaInput.files.length > 0) {
      Array.from(polizaInput.files).forEach(async (file) => {
        await this.processPoliza(file as File);
      });
    }
  }

  processPoliza(file: File) {
    const reader: FileReader = new FileReader();
    if (file.type == "application/pdf") {
      this.polizaImg =
        "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg";
      this.polizaFile = file;
      return;
    }

    const promise: Promise<void> = new Promise((resolve) => {
      reader.onload = () => {
        this.polizaImg = reader.result as string;
        this.polizaFile = file;
        resolve();
      };
      reader.readAsDataURL(file);
    });
    return promise;
  }

  polizaDown() {
    this.service.polizaDown(this.defaults.IdUnidad).subscribe((response) => {
      const contentType = response.headers.get("content-type");
      const exist = mimeTypes[contentType];
      this.downLoadFile(response.body, contentType, "poliza");
    });
  }

  downLoadFile(data: any, contentType: string, filename: string) {
    let blob = new Blob([data], { type: contentType });
    FileSaver.saveAs(blob, filename);
  }
}
